import { Injectable } from '@angular/core'
import { Response } from '@angular/http'
import { Globals } from './../helpers'
import { HttpInterceptor } from './http-error.interceptor'

@Injectable()
export class SyncthingService {
  private syncthingServiceUrl: string

  constructor(private http: HttpInterceptor, private globals: Globals) {
    this.syncthingServiceUrl = globals.url + 'syncthing/'
  }

  public getDiscovery() {
    return this.http
      .get(this.syncthingServiceUrl + 'system/discovery')
      .map((response: Response) => response.json())
  }
}
